module.exports = __webpack_public_path__ + "img/11-girl.7f6b23e6.svg";